import BasicLayout from '@/layouts/basic-layout'

const prefix = 'accounts-actual-receivable-statement-'
export default {
  path: '/report-center/accounts-actual-receivable-statement',
  redirect: {name: `${prefix}index`},
  component: BasicLayout,
  children: [
    {
      path: 'index',
      name: `${prefix}index`,
      meta: {cache: true, title: '实收报表'},
      component: () => import('@/pages/report-center/accounts-actual-receivable-statement/index')
    },
  ]
}
